import React from 'react'

const CacheLoading = () => {
  return (
    <div>Checking for new version...</div>
  )
}

export default CacheLoading